import { useOutletContext } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api, rangeQuery, type MetricsResponse, type StatsResponse } from "../lib/api";
import { OverviewContent } from "../components/OverviewContent";
import { ErrorBox, PageSpinner } from "../components/ui";
import type { SiteOutletContext } from "./SiteLayout";

export default function OverviewPage() {
  const { site, range } = useOutletContext<SiteOutletContext>();

  const stats = useQuery({
    queryKey: ["stats", site.id, range],
    queryFn: () => api.get<StatsResponse>(`/api/sites/${site.id}/stats${rangeQuery(range)}`),
  });

  const metrics = useQuery({
    queryKey: ["metrics", site.id, range],
    queryFn: () => api.get<MetricsResponse>(`/api/sites/${site.id}/metrics${rangeQuery(range, 10)}`),
  });

  if (stats.isLoading || metrics.isLoading) return <PageSpinner />;
  if (stats.error || metrics.error || !stats.data || !metrics.data) {
    return <ErrorBox message="Gagal memuat data statistik." />;
  }

  return <OverviewContent stats={stats.data} metrics={metrics.data} range={range} tz={site.tz} />;
}
